import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { EntityIdInCard } from '../../../components/atoms/EntityIdInCard';
import '../../../components/atoms/ItemCard.scss';
import { ItemCardField } from '../../../components/atoms/ItemCardField';
import { TypePill } from '../../../components/atoms/TypePill';
import { CURRENCY } from '../../../interfaces/enumerables';
import { AadeBookInvoiceType } from '../../../interfaces/myData.interface';
import { invTypeI18nKey } from '../../../interfaces/myDataInvTypes';
import { PATHS } from '../../../navigation/data';

interface Props {
  index: number;
  doc: AadeBookInvoiceType;
}

export const ReceivedDocItemCard = ({ index, doc }: Props) => {
  const { t } = useTranslation();

  const issueDate = useMemo(() => {
    try {
      return new Date(doc.invoiceHeader.issueDate as unknown as string).toLocaleDateString('el-GR');
    } catch {
      return String(doc.invoiceHeader.issueDate);
    }
  }, [doc.invoiceHeader.issueDate]);

  const getProviderUrl = useCallback(() => {
    if (doc.downloadingInvoiceUrl) {
      return (
        <div
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: 'var(--ion-color-primary)',
            zIndex: 1,
          }}
        />
      );
    }
  }, [doc.downloadingInvoiceUrl]);

  return (
    <div className="width-100 itemOfList positionRelative">
      {getProviderUrl()}
      <Link
        to={`${PATHS.RECEIVED_DOCS}/view/${doc.mark}`}
        state={{ doc }}
        className="flex-center-center-row-wrap link-reset card"
        data-testid={`ItemCard_${index}`}
        onClick={(e) => e.stopPropagation()}>
        <div className="received-doc-card-header">
          <EntityIdInCard id={`${doc.invoiceHeader.series}-${doc.invoiceHeader.aa}`} />
          <TypePill
            type={`${doc.invoiceHeader.invoiceType} – ${t(invTypeI18nKey(doc.invoiceHeader.invoiceType), { defaultValue: String(doc.invoiceHeader.invoiceType) })}`}
          />
        </div>
        <div className="flex-space-between-center-row-wrap width-100">
          <ItemCardField
            classes="margin-r-24"
            width="width-180px"
            value={doc.issuer?.name || doc.issuer?.vatNumber || ''}
          />
          <ItemCardField
            classes="margin-r-24"
            width="width-180px"
            value={`${String(doc.invoiceSummary?.totalGrossValue ?? '')} ${CURRENCY.EURO}`}
          />
          <ItemCardField classes="margin-r-24" width="width-180px" value={issueDate} />
        </div>
      </Link>
    </div>
  );
};
